<script>
export default {
  name: "IgCard",
  props: {
    title: {
      type: String,
      default: null
    },
    img1: {
      type: String,
      default: null
    },
    barBtns: {
      type: Array,
      default: null
    },
    type: {
      type: Number,
      default: 1
    },
    value: {
      default: null
    }
  },
  data() {
    return {
      dropMenu: false,
      dropTm1: null
    };
  },
  mounted() {
    // this.reg1();
  },
  beforeDestroy() {
    this.unreg1();
  },
  methods: {
    onVisibilityChange(el, callback) {
      console.log('onVisibilityChange');
      var old_visible;
      return function() {
        var visible = this.$dstd.isElementInViewport(el);
        if (visible != old_visible) {
          old_visible = visible;
          if (typeof callback == "function") {
            callback();
          }
        }
      };
    },
    reg1() {
      if (window.addEventListener) {
        // addEventListener("DOMContentLoaded", handler, false);
        window.addEventListener("load", this.onVisibilityChange, false);
        window.addEventListener("scroll", this.onVisibilityChangendler, false);
        window.addEventListener("resize", this.onVisibilityChange, false);
      } else if (window.attachEvent) {
        // attachEvent("onDOMContentLoaded", handler); // Internet Explorer 9+ :(
        window.attachEvent("onload", this.onVisibilityChange);
        window.attachEvent("onscroll", this.onVisibilityChange);
        window.attachEvent("onresize", this.onVisibilityChange);
      }
    },
    unreg1() {},
    clk(a) {
      console.log("clk." + a);
      switch (a) {
      }
    },
    clkMenu() {
      let i = this.dropMenu;
      this.dropMenu = !i;
      if (this.dropTm1) clearTimeout(this.dropTm1);
      if (this.dropMenu) {
        this.dropTm1 = setTimeout(() => {
          document
            .getElementById("app")
            .addEventListener("click", this.clkMenuBlr, false);
        }, 250);
      }
    },
    clkMenuBlr() {
      // console.log("menuBlr." + this.dropMenu);
      if (this.dropMenu) this.dropMenu = false;
      document
        .getElementById("app")
        .removeEventListener("click", this.clkMenuBlr, false);
    },
    hasBbN(n) {
      let l = this.barBtns;
      return Array.isArray(l) ? this.barBtns.indexOf(n) >= 0 : 0;
    },
    hasBb() {
      let l = this.barBtns;
      return Array.isArray(l) && l.length >= 1;
    }
  }
};
</script>
<template>
  <div>
    <div class="igcard-cont">
      <div class="igcard">
        <!-- <div class="igcard-tbar">

        </div> -->
        <div class="igcard-hdr">
          <a class="heading" v-if="title" @click="$emit('click', value)">
            {{ title }}
          </a>
          <div class="igcard-hdr-btns" v-if="hasBb()">
            <slot name="hdrBtns"></slot>
            <!-- <b-button
              icon-left="trash"
              @click="clkDel"
              rounded
              size="is-small"
              type="is-danger"
            ></b-button> -->
            <!-- <b-button
              v-if="hasBbN('menu')"
              icon-left="ellipsis-h"
              @click="clk('menu')"
              rounded
              size="is-small"
              type="is-light"
            ></b-button> -->
            <a class="button is-rounded is-small" v-if="hasBbN('plus')">
              <b-icon icon="plus"></b-icon>
            </a>
            <div class="ig-dropdown" v-if="$slots.dropmenu">
              <div class="ig-dropdown-trigger">
                <a
                  class="button is-rounded is-small"
                  v-if="$slots.dropmenu"
                  @click="clkMenu"
                >
                  <b-icon icon="ellipsis-h"></b-icon>
                </a>
              </div>
              <div
                ref="dropmenu1"
                class="ig-dropdown-menu"
                v-if="$slots.dropmenu"
                :class="dropMenu ? 'is-active' : ''"
              >
                <div class="ig-dropdown-menu-body">
                  <slot name="dropmenu"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
